import { Directive, ElementRef, Optional, Inject, forwardRef } from "@angular/core";
import { DsStepperComponent } from "../ds-stepper/ds-stepper.component";

@Directive({
  selector: "[dsStepperNext]",
  standalone: true,
})
export class DsStepperNextDirective {
  constructor(
    private elementRef: ElementRef,
    @Optional() @Inject(forwardRef(() => DsStepperComponent)) private stepper?: DsStepperComponent
  ) {
    this.elementRef.nativeElement.addEventListener("click", () => {
      if (this.stepper) {
        this.stepper.next();
      }
    });
  }
}
